import PersistProvider from './PersistProvider';
export default PersistProvider;
